/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const de_sf_logout__logged_out = /** @type {(inputs: {}) => string} */ () => {
	return `Sie wurden erfolgreich abgemeldet`
};

const en_sf_logout__logged_out = /** @type {(inputs: {}) => string} */ () => {
	return `You've been disconnected`
};

const es_sf_logout__logged_out = /** @type {(inputs: {}) => string} */ () => {
	return `Sesión cerrada con éxito`
};

const fr_sf_logout__logged_out = /** @type {(inputs: {}) => string} */ () => {
	return `Déconnexion réussie`
};

const it_sf_logout__logged_out = /** @type {(inputs: {}) => string} */ () => {
	return `Logout eseguito`
};

const nl_sf_logout__logged_out = /** @type {(inputs: {}) => string} */ () => {
	return `Afmelden geslaagd`
};

const pt_sf_logout__logged_out = /** @type {(inputs: {}) => string} */ () => {
	return `Fim de sessão bem-sucedido`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "de" | "en" | "es" | "fr" | "it" | "nl" | "pt" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
export const sf_logout__logged_out = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.sf_logout__logged_out(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("sf_logout__logged_out", locale)
	if (locale === "de") return de_sf_logout__logged_out(inputs)
	if (locale === "en") return en_sf_logout__logged_out(inputs)
	if (locale === "es") return es_sf_logout__logged_out(inputs)
	if (locale === "fr") return fr_sf_logout__logged_out(inputs)
	if (locale === "it") return it_sf_logout__logged_out(inputs)
	if (locale === "nl") return nl_sf_logout__logged_out(inputs)
	return pt_sf_logout__logged_out(inputs)
};